import React from 'react';
import PropTypes from 'prop-types';
import * as moment from 'moment';
import { LOCALES } from '../../i18n/index';
import 'moment/locale/es';
import 'moment/locale/fr';

import './styles.less';

const NotificationItem = ({ item, toggleModal }) => {
  moment.locale(localStorage.getItem('lang') || LOCALES.ENGLISH);
  const time = moment.unix(item.timestamp).utc(0).format('dddd, LT');
  return (
    <div className="item-wrapper notification-item" onClick={toggleModal}>
      <div className="data-wrapper">
        <div className="log-date">{time}</div>
        <div className="log-content">
          <span className="log-device-name">{item.device_name} </span>
          {item.details}
        </div>
      </div>
    </div>
  );
};

NotificationItem.defaultProps = {
  toggleModal: null,
};

NotificationItem.propTypes = {
  item: PropTypes.objectOf(PropTypes.any).isRequired,
  toggleModal: PropTypes.func,
};

export default NotificationItem;
